<template>
    <div>
        <!-- Modal para visualizar informações do cliente -->
        <div class="modal fade" id="mdinformacoescliente" tabindex="-1" aria-labelledby="mdlinformacoescliente" aria-hidden="true" style="z-index: 1050;">
			<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdlinformacoesclientecliente"><i class="fa fa-info-circle"></i> Informações do cliente</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
                    <!-- Dados do cliente -->
					<div class="modal-header" style="background: white; border-bottom: 1px solid #dee2e6; padding-bottom: 15px;">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                    <label for="edclienteinf">Cliente:</label>
                                    <input type="text" class="form-control form-control-sm text-uppercase font-weight-bold" id="edclienteinf" v-bind:value="id+' - '+nomecliente"
                                        data-bv-group=".group" disabled/>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                    <label for="edvlcreditoinf">Crédito:</label>
                                    <input type="text" class="form-control form-control-sm text-right font-weight-bold text-success" id="edvlcreditoinf" v-bind:value="mtdformatavalordecimal(vlcredito, 2)"
                                        data-bv-group=".group" disabled/>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                    <label for="edvlcreditoutilizadoinf">Utilizado:</label>
                                    <input type="text" class="form-control form-control-sm text-right font-weight-bold text-warning" id="edvlcreditoutilizadoinf" v-bind:value="mtdformatavalordecimal(vrTotal, 2)"
                                        data-bv-group=".group" disabled/>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-6 col-xl-2">
                                    <label for="edvlcreditodisponivelinf">Diponível:</label>
                                    <input type="text" v-bind:class="parseFloat(vlcredito) - parseFloat(vrTotal) > 0 ? 'text-success' : 'text-danger'" class="form-control form-control-sm text-right font-weight-bold" id="edvlcreditodisponivelinf" v-bind:value="mtdformatavalordecimal(parseFloat(vlcredito) - parseFloat(vrTotal), 2)"
                                        data-bv-group=".group" disabled/>
                                </div>
                                <div class="col-sm-2 col-md-2 col-lg-2">
                                    <label for="cboplistagem">Listar:</label>
                                    <select name="cboplistagem" class="form-control form-control-sm" id="cbSituacao" v-model="oplistagem" @change.prevent="mtdlistagem()">
                                        <option value="0">Títulos em aberto</option>
                                        <option value="1">Títulos pagos</option>
                                        <option value="2">Pedidos faturados</option>
                                    </select>
                                </div>                                
                            </div>                            
                        </div>                        
					</div>                    
					<div class="modal-body" style="padding-bottom: 0px; padding-left: 0px; padding-right: 0px;">
                        <!-- Títulos em aberto -->
                        <div class="container-fluid" v-show="(mostrar && parseInt(oplistagem) === 0)">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="table-responsive">
                                        <table id="tblistatitrec" class="table table-bordered table-sm table-hover">
                                            <thead class="thead-dark">
                                            <tr>
                                                <th width="150">Nr. Título:</th>
                                                <th width="150">Cobrança:</th>
                                                <th width="150">Auxiliar:</th>
                                                <th width="100">Emissão:</th>
                                                <th width="100">Vencimento:</th>
                                                <th width="100">Vl. Título:</th>
                                                <th width="100">Restante:</th>
                                                <th width="60">Atraso:</th>     
                                                <th width="100">Juros:</th>
                                                <th width="100">Multa:</th>
                                                <th width="150">À receber:</th>                                                
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(titulo, index) in lsttitulos" v-bind:key="index" style="font-size: 12px;">
                                                    <td>{{titulo.codtit}}</td>
                                                    <td>{{titulo.desccob}}</td>
                                                    <td>{{titulo.codauxiliar}}</td>
                                                    <td style="text-align: right;">{{titulo.dtemitit}}</td>
                                                    <td style="text-align: right;">{{titulo.dtventit}}</td>
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vltit), 2)}}</td>
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vlresta), 2)}}</td>
                                                    <td class="text-center">
                                                        <span v-if="parseInt(titulo.atraso) > 0" class="badge badge-pill badge-danger">{{ titulo.atraso }}</span>
                                                        <span v-else></span>
                                                    </td>
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vljuros), 2)}}</td>
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vlmulta), 2)}}</td>                                                    
                                                    <td style="text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(titulo.vlapagar), 2)}}</td>
                                                </tr>
                                            </tbody>                                        
                                        </table>
                                    </div>
                                </div>                                                                               
                            </div>
                        </div>
                        <!-- Títulos pagos -->
                        <div class="container-fluid" v-show="(mostrar && parseInt(oplistagem) === 1)">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="table-responsive">
                                        <table id="tblistatitpag" class="table table-bordered table-sm table-hover">
                                            <thead class="thead-dark">
                                            <tr>
                                                <th width="150">Nr. Título:</th>
                                                <th width="150">Cobrança:</th>
                                                <th width="150">Auxiliar:</th>
                                                <th width="100">Emissão:</th>
                                                <th width="100">Vencimento:</th>
                                                <th width="100">Pagamento:</th>
                                                <th width="60">Atraso:</th>
                                                <th width="100">Vl. Título:</th>                                                  
                                                <th width="100">Juros:</th>
                                                <th width="100">Multa:</th>
                                                <th width="100">Descto(J/M):</th>
                                                <th width="150">Total pago:</th>                                                
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(titulo, index) in lsttitulospagos" v-bind:key="index" style="font-size: 12px;">
                                                    <td>{{titulo.codtit}}</td>
                                                    <td>{{titulo.desccob}}</td>
                                                    <td>{{titulo.codauxiliar}}</td>
                                                    <td style="text-align: right;">{{titulo.dtemitit}}</td>
                                                    <td style="text-align: right;">{{titulo.dtventit}}</td>
                                                    <td style="text-align: right; font-weight: bold;" class="text-success">{{titulo.dtpagtit}}</td>
                                                    <td class="text-center">
                                                        <span v-if="parseInt(titulo.atraso) > 0" class="badge badge-pill badge-danger">{{ titulo.atraso }}</span>
                                                        <span v-else></span>
                                                    </td>                                                    
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vlresta), 2)}}</td>
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vljuros), 2)}}</td>
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.vlmulta), 2)}}</td>                                                    
                                                    <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(titulo.valordescontojurosmulta), 2)}}</td>
                                                    <td style="text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(titulo.vlpagtit) + parseFloat(titulo.vljuros) + parseFloat(titulo.vlmulta), 2)}}</td>
                                                </tr>
                                            </tbody>                                        
                                        </table>
                                    </div>
                                </div>                                                                               
                            </div>
                        </div> 
                        <!-- Pedidos do cliente -->
                        <div class="container-fluid" v-show="(mostrar && parseInt(oplistagem) === 2)">
                            <div class="row" style="margin-top: -10px;">
                                <div class="col-md-3">
                                    <label for="eddtini">De:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtiniinf" v-model="dtiniinf" :config="options" class="form-control form-control-sm"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>								
                                    </div>                        
                                </div>
                                <div class="col-md-3">
                                    <label for="eddtfiminf">até:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtfiminf" v-model="dtfiminf" :config="options" class="form-control form-control-sm"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>																			
                                    </div>                        
                                </div>
                                <div class="col-md-3">
                                    <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdlistagem()" style="margin-top: 20px;"><i class="fa fa-search"></i> Pesquisar</button>
                                </div>
                            </div>
                            <div class="row" style="margin-top: 10px;">
                                <div class="col-lg-12">
                                    <div class="table-responsive">
                                        <table id="tblistatbped" class="table table-bordered table-sm table-hover">
                                            <thead class="thead-dark">
                                            <tr>
                                                <th width="30"></th>
                                                <th>Nr. Pedido:</th>
                                                <th>Dt. fatura:</th>                                                
                                                <th>Vendedor:</th>
                                                <th>Plano:</th>
                                                <th>Rota:</th>
                                                <th>Total:</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(pedido, index) in lstpedidos">
                                                    <tr v-bind:key="index" style="font-size: 12px;">
                                                        <td class="text-center">
                                                            <span v-if="parseFloat(pedido.conferido) === 0" style="font-size: 20px; cursor: pointer;" @click.prevent="mtdexpandirpedidos(index)"><i class="fa fa-chevron-circle-down text-primary"></i></span>
                                                            <span v-else style="font-size: 20px; cursor: pointer;"><i class="fa fa-chevron-circle-up text-primary" @click.prevent="mtdexpandirpedidos(index)"></i></span>													
                                                        </td>                                                        
                                                        <td style="width: 90px; font-weight: bold;">{{mtdformatarzeros(pedido.id, 8)}}</td>
                                                        <td style="width: 140px;">{{pedido.dtfatura}}</td>                                                        
                                                        <td style="width: 180px;">{{pedido.nomevendedor}}</td>
                                                        <td style="width: 180px;">{{pedido.descplano}}</td>
                                                        <td style="width: 180px;">{{pedido.descrota}}</td>
                                                        <td style="width: 120px; text-align: right; font-weight: bold;">{{mtdformatavalordecimal(parseFloat(pedido.totalgeral), 2)}}</td>
                                                    </tr>
                                                    <tr v-bind:key="index">
                                                        <td colspan="7" v-show="parseInt(pedido.conferido) === 1" style="padding-left: 35px; padding-right: 35px;">
                                                            <table id="tbclista" class="table table-bordered table-sm table-hover" style="margin-top: 2px; margin-bottom: 2px;">
                                                                <thead class="thead-light">
                                                                    <tr>
                                                                        <th width="30">Item:</th>
                                                                        <th width="100">Codigo:</th>
                                                                        <th width="300">Descrição:</th>
                                                                        <th width="100">Referência:</th>
                                                                        <th width="40">Und:</th>
                                                                        <th width="40">Marca:</th>
                                                                        <th width="100">Vl. Unitário:</th>
                                                                        <th width="50">Qtd:</th>     
                                                                        <th width="100">Vl. Descto:</th>
                                                                        <th width="100">Vl. Total:</th>
                                                                        <th width="100">Local.:</th>
                                                                        <th width="100">Estoque:</th> 										
                                                                    </tr>																								
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item, indexi) in pedido.itens" style="font-size: 12px;" :key="indexi">
                                                                        <td class="text-center">{{item.item}}</td>
                                                                        <td>{{item.coddig}}</td>
                                                                        <td>{{item.descproduto}}</td>
                                                                        <td>{{item.referencia}}</td>
                                                                        <td>{{item.unditem}}</td>
                                                                        <td>{{item.descmarca}}</td>
                                                                        <td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario), 2)}}</td>
                                                                        <td style="text-align: right;">{{item.qtditem}}</td>
                                                                        <template v-if="parseInt(item.descacres) === 0">
                                                                            <td v-if="parseInt(item.tipodescacres) === 0" style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario) * parseFloat(item.qtditem) * parseFloat(item.valordescacres) / 100 , 2)}}</td>                                                
                                                                            <td v-else style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.valordescacres), 2)}}</td>                                                
                                                                        </template>
                                                                        <template v-else>
                                                                            <td></td>
                                                                        </template>
                                                                        <td style="text-align: right; font-weight: 500;">
                                                                            <i v-show="parseFloat(item.vltotalimposto) > 0" class="fa fa-info-circle text-black-50" v-bind:title="'Imposto do item: R$ '+ mtdformatavalordecimal(parseFloat(item.vltotalimposto), 2)" style="font-size: 18px; float: left;"></i>
                                                                            {{mtdformatavalordecimal(parseFloat(item.vltotal), 2)}}
                                                                        </td>
                                                                        <td>{{item.localizacao}}</td>
                                                                        <td>{{item.descestoque}}</td>
                                                                    </tr>	
                                                                </tbody>
                                                            </table>													
                                                        </td>
                                                    </tr>                                                    
                                                </template>
                                            </tbody>                                        
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>                       
					</div>
                    <div class="modal-footer">                        
                        <div class="container-fluid">
                            <!-- totais dos títulos em aberto -->
                            <div class="row" v-show="mostrar && parseInt(oplistagem) === 0">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-body" style="padding: 15px;">
                                            <div class="row justify-content-center">
                                                <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec">Vencidos <span class="badge badge-danger bdgtitulos">{{ mtdformatavalordecimal(vrVencidos, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(vrJuros, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Títulos <span class="badge badge-info bdgtitulos">{{ lsttitulos.length }}</span></a>
                                                    </ul>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec">A vencer <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(vrAvencer, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vrMulta, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Total geral <span class="badge badge-success bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(vrTotal, 2) }}</span>
                                                        </a>
                                                    </ul>
                                                </div>                                   
                                            </div>
                                        </div>
                                    </div>
                                </div>                 
                            </div>
                            <!-- totais dos títulos baixados -->  
                            <div class="row" v-show="(mostrar && parseInt(oplistagem) === 1)">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-body" style="padding: 15px;">
                                            <div class="row justify-content-center">
                                                <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec">Total juros <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotaljuros, 2) }}</span></a>
                                                        <a class="list-group-item lstdetrec">Total descontos <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotaldescontos, 2) }}</span></a>
                                                    </ul>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6" id="dvselecionados">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec">Total multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vtotalmulta, 2) }}</span></a>                                                    
                                                        <a class="list-group-item lstdetrec">Total recebido <span class="badge badge-info" style="font-size: 12px;">{{ lsttitulospagos.length }}</span>
                                                            <span class="badge badge-warning bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(vtotgeral, 2) }}</span>
                                                        </a>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>                                                                
                            <!-- Total dos pedidos -->
                            <div class="row" v-show="(mostrar && parseInt(oplistagem) === 2)">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-body" style="padding: 15px;">
                                            <div class="row justify-content-center">
                                                <div class="col-sm-12 col-md-6 col-lg-6">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec">Pedidos <span class="badge badge-info bdgtitulos">{{ lstpedidos.length }}</span></a>
                                                    </ul>
                                                </div>
                                                <div class="col-sm-12 col-md-6 col-lg-6" id="dvselecionados">
                                                    <ul class="list-group">
                                                        <a class="list-group-item lstdetrec">Total faturado 
                                                            <span class="badge badge-warning bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(totalfaturado, 2) }}</span>
                                                        </a>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 text-right" style="margin-top: 15px;">
                                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-sign-out"></i> Sair</button>
                                </div>                                
                            </div>
                        </div>
                    </div>					
				</div>
			</div>
		</div>       
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
    name: 'cmpinformacoescliente',
    components:{
    },    
    props:[    
        'id',
        'nomecliente',
        'vlcredito',
        
    ],
    data: function() {
        return {
            mostrar     : false,
            oplistagem  : 0,
            //titulos em aberto
            lsttitulos  : [],
            vrVencidos  : 0,
            vrAvencer   : 0,
            vrJuros     : 0,
            vrMulta     : 0,
            vrTotal     : 0,
            //titulos pagos
            lsttitulospagos : [],
            vtotaldescontos : 0,
            vtotaljuros     : 0,
            vtotalmulta     : 0,
            vtotaltitulos   : 0,
            vtotgeral       : 0,

            //pedidos
            lstpedidos      : [],
            totalfaturado   : 0,
            //detalhes do pedido
            vidpedidodet    : '',
            options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
            },
            dtiniinf       	: util.DataAtual(true),
			dtfiminf       	: util.DataAtual(true)
        };
    },
    methods: { 
        mtdformatavalordecimal(valor, digitos){
            if ($.isNumeric(valor)){
			    return util.formatavalordecimais(valor, digitos);
            }else{
                return '0,00';
            }
		},       
        mtdformatarzeros(str, length){
            return util.formatarzeros(str, length);
        },                       
        mtdlistagem(){
            let vself = this;
            switch (parseInt(vself.oplistagem)) {
                case 0:
                    vself.mtdlistartitulosreceber();
                break;
                case 1:
                    vself.mtdlistartitulospagos();
                break;                
                case 2:
                    vself.mtdlistarpedidosfaturados();
                break;                 
            }
        },
        mtdlistartitulosreceber(){
            let vself       = this;
            let loader      = vself.$loading.show();

            vself.mostrar           = false;
            vself.lsttitulos        = [];
            //iguala totais dos titulos para calcular os selecionados
            vself.vrVencidos        = 0;
            vself.vrAvencer         = 0;
            vself.vrJuros           = 0;
            vself.vrMulta           = 0;
            vself.vrTotal           = 0;            

            let filtro      = ' and t.idcliente='+vself.id+' and t.inativo=0 and t.sttit in ("A", "P")';
            let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'listagem'},
                    {parametro: 'situacao',     valor  : 0},
                    {parametro: 'ordem',        valor  : 2}, 
                    {parametro: 'dtbasecalculo',valor  : util.InverterData(util.DataAtual(true))},                                                
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : '99999999999'},
                    {parametro: 'offset',       valor : '0'}
                ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
            retorno.then(function (response) {
                vself.mostrar     = true;
                vself.lsttitulos  = response.data.lista;
                //iguala totais dos titulos para calcular os selecionados
                vself.vrVencidos        = response.data.vencidos;
                vself.vrAvencer         = response.data.avencer;
                vself.vrJuros           = response.data.totjuros;
                vself.vrMulta           = response.data.totmulta;
                vself.vrTotal           = response.data.totgeral;
                loader.hide();
            }).catch(function (response) {
                vself.lsttitulos = [];
                loader.hide();
            });
        },
        mtdlistartitulospagos(){
            let vself       = this;
            let loader      = vself.$loading.show();
            vself.mostrar   = false;
            //iguala totais dos titulos para calcular os selecionados                
            vself.lsttitulospagos   = [];
            vself.vtotaldescontos   = 0;
            vself.vtotaljuros       = 0;
            vself.vtotalmulta       = 0;
            vself.vtotaltitulos     = 0;
            vself.vtotgeral         = 0; 
            let filtro      = ' and t.idcliente='+vself.id;
            let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'listagem'},
                    {parametro: 'situacao',     valor  : 1},
                    {parametro: 'ordem',        valor  : 2}, 
                    {parametro: 'dtbasecalculo',valor  : util.InverterData(util.DataAtual(true))},                                                
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : '99999999999'},
                    {parametro: 'offset',       valor : '0'}
                ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
            retorno.then(function (response) {
                vself.mostrar     = true;
                //iguala totais dos titulos para calcular os selecionados                
                vself.lsttitulospagos   = response.data.lista;
                vself.vtotaldescontos   = response.data.totaldescontos;
                vself.vtotaljuros       = response.data.totaljuros;
                vself.vtotalmulta       = response.data.totalmulta;
                vself.vtotaltitulos     = response.data.totaltitulos;
                vself.vtotgeral         = response.data.totgeral; 
                loader.hide();
            }).catch(function (response) {
                vself.lsttitulospagos   = [];
                loader.hide();
            });
        },
        mtdlistarpedidosfaturados(){
            var vself           = this;
            vself.lstpedidos    = [];
            vself.totalfaturado	= 0;            
            let loader      = vself.$loading.show();
            let filtro      = 'and p.stpedido=1 and p.idcliente='+vself.id+' and p.dtfatura between "' + util.InverterData(vself.dtiniinf) + ' 00:00:00" and "' + util.InverterData(vself.dtfiminf) + ' 23:59:59"';
            let parametros  = [
                {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',               valor : 'listagem'},
                {parametro: 'filtro',           valor : filtro},
                {parametro: 'limit',            valor : '99999999999'},
                {parametro: 'offset',           valor : '0'}
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
            retorno.then(function (response) {
                let lstpedtmp = response.data.pedidos;
                for (let i = 0; i < lstpedtmp.length; i++) {
                    lstpedtmp[i].conferido = 0;                    
                }
                vself.lstpedidos        = lstpedtmp;
                //totalizadores
                vself.totalfaturado	    = response.data.totalfaturado;
                loader.hide();											
            }).catch(function (response) {
                vself.lstpedidos        = [];
                loader.hide();
            });            
        },
        mtdexpandirpedidos(indice){
            if (parseInt(this.lstpedidos[indice].conferido) === 1){
                this.lstpedidos[indice].conferido = 0;
            }else{
                this.lstpedidos[indice].conferido = 1;
            }
        }       
    },
    mounted: function(){
        let vself = this;
        $("#mdinformacoescliente").on('shown.bs.modal', function(){
            let retm        = util.pri_ult_diames(new Date, true);
            vself.dtiniinf  = retm.primeirodiames;
            vself.dtfiminf  = retm.ultimodiames;            
            vself.mtdlistartitulosreceber();             
        });
        $("#mdinformacoescliente").on('hide.bs.modal', function(){
            vself.mostrar    = false;
            vself.oplistagem = 0;
            vself.lsttitulos = [];
            vself.vrVencidos = 0;
            vself.vrAvencer  = 0;
            vself.vrJuros    = 0;
            vself.vrMulta    = 0;
            vself.vrTotal    = 0;             
        });        
    },
    computed:{

    },
    watch: {

    }
}
</script>